import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "safeImageSrc",
    standalone: false
})
export class SafeImageSrcPipe implements PipeTransform {
	transform(imageDataB64: string | null | undefined): string {
		if (!imageDataB64) {
			return "";
		}

		// Check if it already has data: prefix
		if (imageDataB64.startsWith("data:")) {
			return imageDataB64;
		}

		// Assume it's a JPEG if no prefix is provided
		return `data:image/jpeg;base64,${imageDataB64}`;
	}
}
